import React, { useEffect, useRef, useState } from 'react';
import {
  controlsContainer,
  muteBtn,
  muteIconStyle,
  playIconStyle,
  quizCtaIconStyle,
  quizCtaStyle,
  quizResultBtnStyle,
  quizResultCtaWrapper,
  quizResultDescStyle,
  quizResultHeaderStyle,
  quizResultTitleStyle,
  quizResultWrapper,
  resultImgStyle,
  sponserPlayerContainer,
  sponserVideoPlayer,
  unmuteBtn,
  watchBtnStyle
} from './QuizScreenStyles';
import { useAppStore } from '../../hooks/useAppStore';
import {
  GamificationCampaignStatus,
  GamificationScreens
} from '../../store/interface';
import { DynamicObject } from '../../utils/commonTypes';
import {
  parseGameMapperId,
  triggerPastWinnersCTAEvent,
  triggerQuizEndingEvent
} from '../../utils/watchAndWinUtils';
import { useSearchParams } from 'next/navigation';
import { NavMenuLinks } from '../../utils/constants/RouterConstants';
import { getLiveMatch } from '../../services/apiRequests/LiveMatchService';
import { SPORTS_ROUTE } from '../../utils/constants/ApiConstants';
import { globalUrlHelper } from '../../utils/common';
import { API_STATUS_TYPES } from '../../utils/constants/utilConstants';

const StarIconSvg = () => {
  return (
    <svg
      css={quizCtaIconStyle}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.49995 2.66L9.93328 5.56C10.1266 5.94667 10.4933 6.21333 10.92 6.28L14.12 6.74667L11.8066 9C11.5 9.3 11.3533 9.73333 11.4266 10.16L11.9733 13.3467L9.11328 11.84C8.92662 11.74 8.71328 11.6867 8.49995 11.6867C8.28662 11.6867 8.07328 11.74 7.88662 11.84L5.02662 13.3467L5.57328 10.16C5.64662 9.73333 5.50662 9.3 5.19328 9L2.87995 6.74667L6.07995 6.28C6.50662 6.22 6.87995 5.94667 7.06662 5.56L8.49328 2.66M8.49328 2C8.25995 2 8.02662 2.12 7.90662 2.36667L6.47328 5.26667C6.37995 5.46 6.19328 5.59333 5.97995 5.62667L2.77995 6.09333C2.23995 6.17333 2.02662 6.83333 2.41328 7.21333L4.72662 9.46667C4.87995 9.62 4.95328 9.83333 4.91328 10.0467L4.36662 13.2333C4.29328 13.66 4.63328 14 5.01328 14C5.11328 14 5.21995 13.9733 5.31995 13.92L8.17995 12.4133C8.27328 12.36 8.37995 12.34 8.48662 12.34C8.59328 12.34 8.69328 12.3667 8.79328 12.4133L11.6533 13.92C11.7533 13.9733 11.86 14 11.96 14C12.34 14 12.68 13.6533 12.6066 13.2333L12.06 10.0467C12.0266 9.83333 12.0933 9.61333 12.2466 9.46667L14.56 7.21333C14.9466 6.83333 14.7333 6.17333 14.1933 6.09333L10.9933 5.62667C10.78 5.59333 10.5933 5.46 10.5 5.26667L9.06662 2.36667C8.94662 2.12 8.71328 2 8.47995 2H8.49328Z"
        fill="white"
      />
    </svg>
  );
};

const CricketBallIconSvg = () => {
  return (
    <svg
      css={quizCtaIconStyle}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7137 3.28665C11.4138 1.98665 9.70735 1.33331 8.00089 1.33331C6.29444 1.33331 4.58798 1.98665 3.28814 3.28665C0.681787 5.89331 0.681787 10.1133 3.28814 12.7133C4.58798 14.0133 6.29444 14.6666 8.00089 14.6666C9.70735 14.6666 11.4138 14.0133 12.7137 12.7133C15.32 10.1066 15.32 5.88665 12.7137 3.28665ZM2.00163 7.99998C2.00163 6.39998 2.62822 4.89331 3.76141 3.75998C4.89461 2.62665 6.40109 1.99998 8.00089 1.99998C9.49405 1.99998 10.8939 2.54665 11.9937 3.53331L3.53477 11.9933C2.54823 10.8933 2.00163 9.48665 2.00163 7.99998ZM12.2404 12.24C11.1072 13.3733 9.6007 14 8.00089 14C6.50774 14 5.10791 13.4533 4.00805 12.4666L12.467 4.00665C13.4536 5.10665 14.0002 6.51331 14.0002 7.99998C14.0002 9.59998 13.3736 11.1066 12.2404 12.24ZM3.76146 10.36L5.1748 8.94664C5.30813 8.81331 5.30813 8.60665 5.1748 8.47331C5.04146 8.33998 4.83479 8.33998 4.70146 8.47331L3.28813 9.88664C3.15479 10.02 3.15479 10.2266 3.28813 10.36C3.42146 10.4933 3.62813 10.4933 3.76146 10.36ZM7.76782 6.3533L6.35449 7.76664C6.22115 7.89997 6.01449 7.89997 5.88115 7.76664C5.74782 7.6333 5.74782 7.42664 5.88115 7.2933L7.29449 5.87997C7.42782 5.74663 7.63449 5.74663 7.76782 5.87997C7.90115 6.0133 7.90115 6.21997 7.76782 6.3533ZM8.94084 5.17333L10.3542 3.76C10.4875 3.62667 10.4875 3.42 10.3542 3.28667C10.2208 3.15333 10.0142 3.15333 9.88084 3.28667L8.46751 4.7C8.33418 4.83333 8.33418 5.04 8.46751 5.17333C8.60084 5.30667 8.80751 5.30667 8.94084 5.17333ZM5.64778 12.24L7.06112 10.8267C7.19445 10.6933 7.40112 10.6933 7.53445 10.8267C7.66779 10.96 7.66779 11.1667 7.53445 11.3L6.12112 12.7133C5.98778 12.8467 5.78112 12.8467 5.64778 12.7133C5.51445 12.58 5.51445 12.3733 5.64778 12.24ZM9.64747 8.23332L8.23414 9.64665C8.1008 9.77999 8.1008 9.98665 8.23414 10.12C8.36747 10.2533 8.57414 10.2533 8.70747 10.12L10.1208 8.70665C10.2541 8.57332 10.2541 8.36665 10.1208 8.23332C9.98747 8.09999 9.78081 8.09999 9.64747 8.23332ZM12.2405 5.63998C12.3738 5.50664 12.5805 5.50664 12.7138 5.63998C12.8472 5.77331 12.8472 5.97998 12.7138 6.11331L11.3005 7.52665C11.1672 7.65998 10.9605 7.65998 10.8272 7.52665C10.6938 7.39331 10.6938 7.18665 10.8272 7.05331L12.2405 5.63998Z"
        fill="white"
      />
    </svg>
  );
};
const PlayIconSvg = () => {
  return (
    <svg
      css={[quizCtaIconStyle, playIconStyle]}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 3.50065L13.3333 8.50065L4.66667 13.5073V3.50065ZM4.66667 2.83398C4.32 2.83398 4 3.11398 4 3.50065V13.5073C4 13.894 4.32 14.174 4.66667 14.174C4.78 14.174 4.89333 14.1473 5 14.0807L13.6667 9.07398C14.1133 8.82065 14.1133 8.17398 13.6667 7.92065L5 2.92732C4.89333 2.86732 4.78 2.83398 4.66667 2.83398Z"
        fill="white"
      />
    </svg>
  );
};

const getQuizStatusInfo = (
  campaignStatus: GamificationCampaignStatus,
  hasQuestions: boolean,
  t: DynamicObject // Gamification translations
) => {
  const quizInfo = {
    scheduled: {
      title: t['QUIZ_SCHEDULED_TITLE'],
      description: t['QUIZ_SCHEDULED_DESCRIPTION']
    },
    emptyQuestions: {
      title: t['QUIZ_EMPTY_QUESTIONS_TITLE'],
      description: t['QUIZ_EMPTY_QUESTIONS_DESCRIPTION']
    },
    quizEnded: {
      title: t['QUIZ_ENDED_TITLE'],
      description: t['QUIZ_ENDED_DESCRIPTION']
    },
    completed: {
      title: t['QUIZ_COMPLETED_TITLE'],
      description: t['QUIZ_COMPLETED_DESCRIPTION']
    }
  };
  switch (true) {
    case campaignStatus === GamificationCampaignStatus.SCHEDULED: {
      return quizInfo.scheduled;
    }
    case campaignStatus === GamificationCampaignStatus.ACTIVE &&
      !hasQuestions: {
      return quizInfo.emptyQuestions;
    }
    case campaignStatus === GamificationCampaignStatus.COMPLETED: {
      return quizInfo.quizEnded;
    }
  }

  return quizInfo.completed;
};

const QuizResult = () => {
  const searchParams = useSearchParams();
  const gameMapperId = parseGameMapperId(
    searchParams.get('game_mapper_id') || ''
  );
  const {
    gamificationState = {},
    setGamificationState,
    translations
  } = useAppStore();
  const { config = null, campaignStatus, questions } = gamificationState;
  const [liveMatchId, setLiveMatchId] = useState<string>();
  const [liveMatchApiStatus, setLiveMatchApiStatus] =
    useState<API_STATUS_TYPES>(API_STATUS_TYPES.idle);
  const hasQuestions = !!questions?.length;
  const quizInfo = getQuizStatusInfo(
    campaignStatus as GamificationCampaignStatus,
    hasQuestions,
    translations?.gamification
  );

  const pastWinnersBtnHandler = (e: React.SyntheticEvent) => {
    e.preventDefault();
    triggerPastWinnersCTAEvent(gameMapperId as string);
    setGamificationState({ currentScreen: GamificationScreens.Winners });
  };

  const explorIltBtnHandler = (e: React.SyntheticEvent) => {
    e.preventDefault();
    window.location.href = NavMenuLinks.ILT_20;
  };
  const watchLiveBtnHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    const matchSlug = 'LiveMatch';
    const redirectionUrl = liveMatchId
      ? `/${SPORTS_ROUTE}/live-streaming/${process.env.NEXT_PUBLIC_ILT_TOURNAMENT_ID}/${matchSlug}/${liveMatchId}`
      : `/${SPORTS_ROUTE}`;

    window.location.href = globalUrlHelper(redirectionUrl);
  };

  const fetchLiveMatchId = async () => {
    try {
      const result = await getLiveMatch();
      const matchId = result?.assetId;
      const isLiveMatch =
        result?.assetType.replace(' ', '').toLowerCase() === 'consumptionpage';

      if (isLiveMatch) {
        setLiveMatchId(matchId);
      }
    } catch (e) {
      console.error(e);
    }
    setLiveMatchApiStatus(API_STATUS_TYPES.success);
  };

  useEffect(() => {
    triggerQuizEndingEvent(gameMapperId as string);
    fetchLiveMatchId();
  }, []);

  return (
    <div css={quizResultWrapper}>
      <div css={quizResultHeaderStyle}>
        <h3 css={quizResultTitleStyle}>{quizInfo?.title}</h3>
        <p css={quizResultDescStyle}>{quizInfo?.description}</p>
      </div>
      <div css={quizResultCtaWrapper}>
        <button
          type="button"
          onClick={pastWinnersBtnHandler}
          css={[quizCtaStyle, quizResultBtnStyle]}>
          <StarIconSvg />
          {translations?.gamification?.PAST_WINNERS}
        </button>
        {!liveMatchId && liveMatchApiStatus === API_STATUS_TYPES.success && (
          <button
            type="button"
            onClick={explorIltBtnHandler}
            css={[quizCtaStyle, quizResultBtnStyle]}>
            <CricketBallIconSvg />
            {translations?.gamification?.EXPLORE_ILT20}
          </button>
        )}
        {liveMatchId && liveMatchApiStatus === API_STATUS_TYPES.success && (
          <button
            type="button"
            onClick={watchLiveBtnHandler}
            css={[quizCtaStyle, watchBtnStyle]}>
            <PlayIconSvg />
            {translations?.gamification?.WATCH_LIVE_MATCH || 'Watch live match'}
          </button>
        )}
      </div>
      {config?.resultScreenVideoPWA ? (
        <div css={sponserPlayerContainer}>
          <video
            css={sponserVideoPlayer}
            autoPlay
            muted
            controls
            src={config?.resultScreenVideoPWA}></video>
        </div>
      ) : config?.resultScreenImage ? (
        <img
          css={resultImgStyle}
          src={config?.resultScreenImage}
          alt="Result Image"
        />
      ) : null}
    </div>
  );
};

export default QuizResult;
